"use client";

import styles from "./index.module.css";

type SideRailProductTitleProps = {
  title?: string;
};

export default function SideRailProductTitle({
  title,
}: SideRailProductTitleProps) {
  if (!title) {
    return null;
  }

  return <p className={styles.productTitle}>{title}</p>;
}
